import React from 'react';
import './MessagesDisplay.css';

/**
 * Small indicator showing available messages
 * @param {Object} props
 * @param {number} props.freeMessages - Daily free messages remaining
 * @param {number} props.purchasedMessages - Purchased messages
 * @param {boolean} props.loading - Whether messages are loading
 * @param {Function} props.onClick - Handler when clicked (to buy more)
 * @param {string} props.variant - Display variant ('compact' | 'full')
 */
export default function MessagesDisplay({
  freeMessages = 0,
  purchasedMessages = 0,
  loading = false,
  onClick,
  variant = 'compact',
}) {
  const totalMessages = freeMessages + purchasedMessages;

  if (variant === 'compact') {
    return (
      <button
        className={`messages-display-compact ${totalMessages === 0 ? 'empty' : ''}`}
        onClick={onClick}
        disabled={loading}
        title={`${freeMessages} daily + ${purchasedMessages} purchased messages`}
      >
        <span className="messages-envelope" aria-hidden>
          📧
        </span>
        <span className="messages-count">
          {loading ? '-' : totalMessages}
        </span>
      </button>
    );
  }

  return (
    <div className="messages-display-full">
      <div className="messages-header">
        <span className="messages-envelope" aria-hidden>
          📧
        </span>
        <span className="messages-label">Messages</span>
      </div>
      <div className="messages-breakdown">
        <div className="messages-row">
          <span className="messages-type">Daily (free)</span>
          <span className={`messages-value ${freeMessages === 0 ? 'empty' : ''}`}>
            {loading ? '-' : freeMessages}
          </span>
        </div>
        <div className="messages-row">
          <span className="messages-type">Purchased</span>
          <span className="messages-value purchased">
            {loading ? '-' : purchasedMessages}
          </span>
        </div>
        <div className="messages-divider"></div>
        <div className="messages-row total">
          <span className="messages-type">Total</span>
          <span className={`messages-value ${totalMessages === 0 ? 'empty' : ''}`}>
            {loading ? '-' : totalMessages}
          </span>
        </div>
      </div>
      {onClick && (
        <button className="messages-buy-button" onClick={onClick}>
          <span>&#128142;</span>
          <span>Buy More</span>
        </button>
      )}
    </div>
  );
}
